import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CheckboxItemComponent } from '@app/components/pl-checkbox/checkboxItem/checkboxItem.component';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [CommonModule, PlIconModule, SharedModule, FormsModule, PlSlicePipeModule],
  declarations: [CheckboxItemComponent],
  exports: [CheckboxItemComponent],
})
export class CheckboxItemModule {}
